var _style, _defs, _mask, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRejectedRegistryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 24",
    style: {
      enableBackground: "new 0 0 36 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D9D9D9;filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st1{mask:url(#mask0_3560_28477_00000033331548502468632370000000212849524230055323_);}\r\n\t.st2{fill:#15B79E;}\r\n\t.st3{fill:#EF4444;}\r\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 5,
    y: 5.4,
    width: 14,
    height: 13.2
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5.4,
    width: 14,
    height: 13.2,
    id: "mask0_3560_28477_00000033331548502468632370000000212849524230055323_"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12,11.4c-0.8,0-1.5-0.3-2.1-0.9C9.3,9.9,9,9.2,9,8.4c0-0.8,0.3-1.5,0.9-2.1c0.6-0.6,1.3-0.9,2.1-0.9 s1.5,0.3,2.1,0.9C14.7,6.9,15,7.6,15,8.4c0,0.8-0.3,1.5-0.9,2.1C13.5,11.1,12.8,11.4,12,11.4z M5,18.6V17c0-0.4,0.1-0.8,0.4-1.2 c0.2-0.4,0.6-0.6,1-0.8c0.9-0.5,1.9-0.8,2.8-1c0.9-0.2,1.9-0.3,2.8-0.3s1.9,0.1,2.8,0.3c0.9,0.2,1.9,0.6,2.8,1 c0.4,0.2,0.7,0.5,1,0.8c0.2,0.4,0.4,0.7,0.4,1.2v1.6H5z M6,17.6h12V17c0-0.2-0.1-0.4-0.2-0.6c-0.1-0.2-0.3-0.4-0.6-0.5 c-0.8-0.4-1.7-0.7-2.5-0.9c-0.9-0.2-1.8-0.3-2.6-0.3s-1.8,0.1-2.6,0.3c-0.9,0.2-1.7,0.5-2.5,0.9c-0.3,0.1-0.5,0.3-0.6,0.5 C6.1,16.5,6,16.7,6,17V17.6z M12,10.4c0.6,0,1-0.2,1.4-0.6C13.8,9.4,14,8.9,14,8.4s-0.2-1-0.6-1.4C13,6.6,12.6,6.4,12,6.4 S11,6.6,10.6,7C10.2,7.4,10,7.8,10,8.4s0.2,1,0.6,1.4C11,10.2,11.4,10.4,12,10.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Cancel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "st3",
    d: "M23.1,15.4l2.9-2.9l2.9,2.9l0.6-0.6L26.6,12l2.9-2.9l-0.6-0.6L26,11.4l-2.9-2.9l-0.6,0.6l2.9,2.9 l-2.9,2.9L23.1,15.4z M26,19.2c-1,0-1.9-0.2-2.8-0.6c-0.9-0.4-1.6-0.9-2.3-1.5c-0.6-0.6-1.2-1.4-1.5-2.3C19,13.9,18.8,13,18.8,12 s0.2-1.9,0.6-2.8c0.4-0.9,0.9-1.6,1.5-2.3c0.6-0.6,1.4-1.2,2.3-1.5C24.1,5,25,4.8,26,4.8s1.9,0.2,2.8,0.6c0.9,0.4,1.6,0.9,2.3,1.5 c0.6,0.6,1.2,1.4,1.5,2.3c0.4,0.9,0.6,1.8,0.6,2.8s-0.2,1.9-0.6,2.8c-0.4,0.9-0.9,1.6-1.5,2.3c-0.6,0.6-1.4,1.2-2.3,1.5 C27.9,19,27,19.2,26,19.2z M26,18.4c1.8,0,3.3-0.6,4.5-1.9c1.2-1.2,1.9-2.7,1.9-4.5c0-1.8-0.6-3.3-1.9-4.5 c-1.2-1.2-2.7-1.9-4.5-1.9c-1.8,0-3.3,0.6-4.5,1.9c-1.2,1.2-1.9,2.7-1.9,4.5c0,1.8,0.6,3.3,1.9,4.5C22.7,17.8,24.2,18.4,26,18.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedRegistryIcon);
export default __webpack_public_path__ + "static/media/rejected-registry-icon.1d24f8045d0962e6a17bc31138fca775.svg";
export { ForwardRef as ReactComponent };